import { combineEpics, ofType } from 'redux-observable';
import { filter, delay, map } from 'rxjs/operators';
import intervalInit from '@actions/interval';

const interval = (action$, state$) => {
  return action$.pipe(
    ofType('INTERVAL_COMPLETE'),
    delay(15000),
    filter(() => state$.value.player.isAuthenticated),
    map(action => ({
      type: 'INTERVAL_INIT',
      payload: action.payload,
    }))
  );
};

const restartInterval = action$ =>
  action$.pipe(
    ofType('INTERVAL_INIT'),
    map(action => intervalInit(action.payload))
  );

const startIntervalOnSignIn = action$ =>
  action$.pipe(
    ofType(
      'SIGNINV2_COMPLETE',
      'SIGNINWITHCODE_COMPLETE',
      'SIGNIN_PNP_COMPLETE'
    ),
    filter(action => action.payload?.sessionId),
    map(action => intervalInit(action.payload.sessionId))
  );

export default combineEpics(interval, restartInterval, startIntervalOnSignIn);
